module.exports = __webpack_public_path__ + "img/mat_214.07cbf0aa.png";